import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-701df069.js';
import { D as Divider } from '../../Divider/Divider-092b5ada.js';
import { T as Text } from '../../Text/Text-e8de28f3.js';
import { S as StyledList } from '../MenuList/MenuList-56e70357.js';
import { T as TaktIdProvider } from '../../TaktIdContext/TaktIdContext-f8f7a95b.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-39f30e88.js';

const MenuDivider = /*#__PURE__*/styled(Divider).withConfig({
  componentId: "sc-storm-ui-30045578__sc-pf1wj0-0"
})(["margin:", " 0;"], ({
  theme
}) => theme.spacing.mini);
MenuDivider.displayName = 'MenuDivider';
const MenuItemGroupListItem = /*#__PURE__*/styled('li').withConfig({
  componentId: "sc-storm-ui-30045578__sc-pf1wj0-1"
})(["text-align:start;:first-child ", "{display:none;};"], MenuDivider);
MenuItemGroupListItem.displayName = 'MenuItemGroupListItem';
const MenuItemGroupLabel = /*#__PURE__*/styled(Text).attrs({
  type: 'span',
  textColor: 'tertiary'
}).withConfig({
  componentId: "sc-storm-ui-30045578__sc-pf1wj0-2"
})(["color:", ";user-select:none;font-weight:bold;font-size:", ";padding:1px 11px 0px 11px;text-transform:none;", ""], ({
  theme
}) => theme.dropdown.group.headingColor, ({
  theme
}) => theme.typography.size.base, isMobile(css(["", ";"], ({
  theme
}) => theme.typography.mobile.base)));
MenuItemGroupLabel.displayName = 'MenuItemGroupLabel';
const MenuItemGroup = ({
  children,
  label,
  onClick,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('menu-item-group')
}, /*#__PURE__*/React__default.createElement(MenuItemGroupListItem, _extends({}, rest, {
  role: "group"
}), /*#__PURE__*/React__default.createElement(MenuDivider, null), label && /*#__PURE__*/React__default.createElement(MenuItemGroupLabel, null, label), /*#__PURE__*/React__default.createElement(StyledList, null, children)));
MenuItemGroup.propTypes = {
  label: PT.node
};
MenuItemGroup.defaultProps = {
  label: undefined
};
var MenuItemGroup$1 = MenuItemGroup;

export { MenuItemGroup$1 as M };
//# sourceMappingURL=MenuItemGroup-28cf0f0c.js.map
